<template>
  <div class="relative bg-white">
    <div
      class="hidden sm:block absolute bottom-0 top-0 left-0 right-0 z-2"
      :class="overlayClass"
    />

    <img
      :src="require(`@/assets/images/redesign-placeholders/${image}`)"
      :srcset="
        require(`@/assets/images/redesign-placeholders/${image}`) +
        ' 640w, ' +
        require(`@/assets/images/redesign-placeholders/${image}`) +
        ' 2048w'
      "
      alt="Farming Family"
      class="image-cover object-center sm:absolute bottom-0 top-0 left-0 right-0 z-1 relative"
    />

    <div class="container-padding-x">
      <div class="max-w-7xl mx-auto sm:text-white relative z-3 py-6 sm:py-32 sm:block sm:bg-transparent"
      :class="forceNarrowHeight ? 'md:py-32 lg:py-32' : 'md:py-48 lg:py-64'"
      >
        <div class="md:w-6/12">
          <slot name="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetHeroBanner',
  props: {
    image: {
      type: String,
      required: true
    },
    overlayClass: {
      type: String,
      required: false
    },
    forceNarrowHeight: {
      type: Boolean,
      required: false
    }
  }
}
</script>
